import rentObjectBookingExtrasService from "@/services/rentObjectBookingExtrasService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      await rentObjectBookingExtrasService.create(formData);
      dispatch(
        "common/showSuccess",
        "Buchungsextra wurde erfolgreich gespeichert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Buchungsextra für dieses Objekt konnte nicht erstellt werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }, formData) {
    try {
      const res = await rentObjectBookingExtrasService.findAll(formData);
      commit("setAll", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Buchungsextras für dieses Objekt konnten nicht geladen werden." + error,
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await rentObjectBookingExtrasService.delete({ id });
      dispatch(
        "common/showSuccess",
        "Buchungsextra wurde erfolgreich gelöscht.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Buchungsextra  für dieses Objekt konnte nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
